// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"defc6316","453":"6322c03e","732":"c4003581","977":"96078de4"}[chunkId] + ".chunk.js";
};